import { render, staticRenderFns } from "./StatValueKey.vue?vue&type=template&id=57a8ee82&scoped=true&"
import script from "./StatValueKey.vue?vue&type=script&lang=js&"
export * from "./StatValueKey.vue?vue&type=script&lang=js&"
import style0 from "./StatValueKey.vue?vue&type=style&index=0&id=57a8ee82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a8ee82",
  null
  
)

export default component.exports